import "../chunk-PKUHTIDK.js";
import { setSubitemAttrValue, setGlobalAttrValue, getClassName, getStyle, row } from "./index";
const api = ["state"];
const renderless = (props, { computed, reactive }, { parent }) => {
  const api2 = {};
  const state = reactive({
    row: computed(() => api2.row()),
    style: computed(() => api2.getStyle()),
    className: computed(() => api2.getClassName())
  });
  Object.assign(api2, {
    state,
    row: row(parent),
    setGlobalAttrValue,
    setSubitemAttrValue,
    getStyle: getStyle({ props, state }),
    getClassName: getClassName({ api: api2, props })
  });
  return api2;
};
export {
  api,
  renderless
};
